// import React from "react";
// import "../App.css";
// import logo from "../Assets/Images/cryoko_logo.png"

// const Navbar = () => {
//   return (
//     <nav className="navbar navbar-expand-lg navbar-custom mt-3 pt-4">
//       <div className="container-fluid mt-lg-2">
//         {/* Logo */}
//         <a className="navbar-brand logo-text" href="/">
//           <img src={logo} className="cryoLogo" alt="logo" />
//         </a>

//         {/* Mobile Toggle */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarContent"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         {/* Menu */}
//         <div className="collapse navbar-collapse" id="navbarContent">
//           {/* Center Menu */}
//           <ul className="navbar-nav mx-auto nav-center">
//             <li className="nav-item">
//               <a className="nav-link cryoko-link active" href="#home">
//                 Home
//               </a>
//             </li>

//             <li className="nav-item">
//               <a className="nav-link cryoko-link" href="#about">
//                 About
//               </a>
//             </li>

//             <li className="nav-item">
//               <a className="nav-link cryoko-link" href="#services">
//                 Services
//               </a>
//             </li>

//             <li className="nav-item">
//               <a className="nav-link cryoko-link" href="#contact">
//                 Contact
//               </a>
//             </li>
//           </ul>

//           {/* Right Button */}
//           <div className="nav-btn-wrapper">
//             <button className="cryoko-btn">Get Started</button>
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;


import React from "react";
import "../App.css";
import logo from "../Assets/Images/cryoko_logo.png";

const Navbar = () => {
  const handleScroll = (id) => {
    const section = document.getElementById(id);

    if (section) {
      const navbarHeight = 100; // Adjust if your navbar height changes

      const sectionPosition =
        section.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: sectionPosition - navbarHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-custom mt-3 pt-4">
      <div className="container-fluid mt-lg-2">
        {/* Logo */}
        <a
          className="navbar-brand logo-text"
          href="/"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        >
          <img src={logo} className="cryoLogo" alt="logo" />
        </a>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav mx-auto nav-center">
            <li className="nav-item">
              <button
                className="nav-link cryoko-link active border-0 bg-transparent"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                Home
              </button>
            </li>

            <li className="nav-item">
              <button
                className="nav-link cryoko-link border-0 bg-transparent"
                onClick={() => handleScroll("about")}
              >
                About
              </button>
            </li>

            <li className="nav-item">
              <button
                className="nav-link cryoko-link border-0 bg-transparent"
                onClick={() => handleScroll("services")}
              >
                Services
              </button>
            </li>

            <li className="nav-item">
              <button
                className="nav-link cryoko-link border-0 bg-transparent"
                onClick={() => handleScroll("contact")}
              >
                Contact
              </button>
            </li>
          </ul>

          {/* Right Button */}
          <div className="nav-btn-wrapper">
            <button
              className="cryoko-btn"
              onClick={() => handleScroll("contact")}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;